import axios from "axios";
import { attachRequestInterceptor } from "./requestInterceptor";
import { attachResponseInterceptor } from "./responseInterceptor";

const environment = process.env.REACT_APP_ENVIRONMENT;
const apiVersion = process.env.REACT_APP_API_VERSION;

const isLocalhost =
    typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

const baseURL = isLocalhost
    ? `http://localhost:5002/${apiVersion}/`
    : environment === "DEVELOPMENT"
    ? `http://localhost:5002/${apiVersion}/`
    : `https://api.antravelsint.com/tam/${apiVersion}/`;

export const API = axios.create({
    baseURL,
    timeout: 5000,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
        "Content-Type": "application/json",
    },
});

attachRequestInterceptor(API);
attachResponseInterceptor(API);
